module.exports = __webpack_public_path__ + "img/logo-short-h.a40c6f19.png";